import Select from "react-select";
import type2Select from "../../Assets/Image/radio-button-type-2-selected.svg";
import type2UnSelect from "../../Assets/Image/radio-button-typ-2-unselected.svg";
import Icon from "../icons";

export default function CheckboxSelect(props) {
  const {
    options = [],
    isMulti = true,
    type,
    placeholder,
    // flexible prop names:
    value: valueProp,
    selectedOptions,
    onChange,
    selectChange,
    handleChange,
    classNamePrefix,
  } = props;

  // resolve handler (support any prop name the parent used)
  const changeHandler = onChange || selectChange || handleChange;

  // Map incoming primitive values (e.g. [1,2]) -> option objects expected by react-select.
  const buildValueForSelect = () => {
    const incoming = valueProp ?? selectedOptions ?? null;
    if (incoming == null) return isMulti ? [] : null;

    // Multi-select expected values:
    if (isMulti) {
      if (Array.isArray(incoming)) {
        // array of primitives -> map to options
        if (incoming.length > 0 && typeof incoming[0] !== "object") {
          return options.filter((o) => incoming.includes(o.value));
        }
        // array of option objects already
        return incoming;
      }
      // single object -> convert to array
      return typeof incoming === "object" ? [incoming] : [];
    }

    // Single-select expected a single object (or null)
    if (Array.isArray(incoming)) {
      return options.find((o) => o.value === incoming[0]) || null;
    }
    if (typeof incoming === "object") return incoming;
    // primitive
    return options.find((o) => o.value === incoming) || null;
  };

  const resolvedValue = buildValueForSelect();

  // When Select changes, pass the value through to parent using parent's handler.
  // Keep the handler signature identical to react-select
  const onSelectChange = (selected) => {
    if (typeof changeHandler === "function") changeHandler(selected);
  };

  const checkboxOption = (optionProps) => {
    const { data, innerRef, innerProps, isSelected } = optionProps;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="d-flex align-items-center px-2 py-1 "
      >
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => {}}
          style={{ accentColor: "#8979ff" }}
          className="me-2 custom-drop-select__checkbox e-cursor-pointer"
        />
        <label className="e-cursor-pointer">{data.label}</label>
      </div>
    );
  };

  const iconOption = (optionProps) => {
    const { data, innerRef, innerProps, isSelected } = optionProps;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="d-flex column-gap-2  align-items-center px-2 py-1 e-cursor-pointer"
      >
        <img
          src={isSelected ? type2Select : type2UnSelect}
          className="e-cursor-pointer"
          alt="select"
        />
        <label className="e-cursor-pointer">{data.label}</label>
      </div>
    );
  };

  const CustomDropdownIndicator = () => (
    <Icon icon="drop-arrow-down" size={12} className='me-2 ' />
    // </components.DropdownIndicator>
  );

  return (
    <div className="select-wrapper position-relative h-100">
      <Select
        options={options}
        isMulti={isMulti}
        closeMenuOnSelect={true}
        isSearchable={false}
        hideSelectedOptions={false}
        components={{
          Option: type === 2 ? iconOption : checkboxOption,
          SingleValue: () => null,
          MultiValue: () => null,
          ValueContainer: ({ children, ...rest }) => (
            <div {...rest.innerProps} className="d-flex align-items-center">
              <span
                style={{
                  color: "#1D1D1B",
                  marginTop: "-0rem",
                  marginLeft: ".5rem",
                }}
              >
                {placeholder}
              </span>
              {children}
            </div>
          ),
          DropdownIndicator: CustomDropdownIndicator,
        }}
        onChange={onSelectChange}
        value={resolvedValue}
        placeholder=""
        classNamePrefix={classNamePrefix ?? "custom-drop-select"}
        styles={{
          control: (styles) => ({
            ...styles,
            cursor: "pointer",
            background: "transparent",
            border: "none",
            boxShadow: "none",
            fontFamily:"Poppins",
            fontWeight:"400",
            fontSize:"14px",
            minHeight: "38px",
            paddingTop: "2px",
          }),
          option: (styles) => ({ ...styles, backgroundColor: "transparent" }),
          menu: (styles) => ({
            ...styles,
            width: "fit-content",
            backgroundColor: "#fffafc",
          }),
          container: (styles) => ({ ...styles, width: "fit-content" }),
          multiValue: (styles) => ({ ...styles, display: "none" }),
          clearIndicator: (styles) => ({ ...styles, display: "none" }),
          placeholder: (styles) => ({
            ...styles,
            marginTop: "-2rem",
            color: "#1D1D1B",
          }),
        }}
      />
    </div>
  );
}
